import type { ChatTask } from "@/sdk/agent/chat";
import type { QueuedChatProps } from "./QueuedChat";
import { QueuedChat } from "./QueuedChat";

export interface ChatListProps extends Pick<QueuedChatProps, "onChatSelected"> {
    chats: ChatTask[];
    isSelectedChat: (chat: ChatTask) => boolean;
}

export function FlatChatList({ chats, onChatSelected, isSelectedChat }: ChatListProps) {
    const avatars = chats.map((chat: ChatTask) => {
        const isChatSelected = isSelectedChat(chat);

        return (
            <QueuedChat
                key={`chat-select-chatId:${chat.chatId}`}
                chat={chat}
                onChatSelected={onChatSelected}
                isChatSelected={isChatSelected}
            />
        );
    });

    return avatars;
}
